export const situacoes = [
  {
    id: 1,
    nome: "Sem Manifestação",
    field: "SEM_MANIFESTACAO",
    cor: "#BFBFBF",
  },
  {
    id: 2,
    nome: "Confirmação da operação",
    field: "CONFIRMACAO",
    cor: "#4FBB53",
  },
  {
    id: 3,
    nome: "Ciência da emissão",
    field: "CIENCIA",
    cor: "#004780",
  },
  {
    id: 4,
    nome: "Desconhecimento da operação",
    field: "DESCONHECIMENTO",
    cor: "#DC3545",
  },
  {
    id: 5,
    nome: "Operação não realizada",
    field: "NAO_REALIZADA",
    cor: "#EA9D2B",
  },
];